import type { App } from 'vue'
import { ComponentI } from '@/typescript/types/abstracts/plugins/ComponentTypes'
import { Plugin } from 'vue'

const initInjectedComponents: Plugin<[]> = {
  async install(vue: App) {
    const componentList: Record<string, ComponentI> = import.meta.glob('../components/ui/**/*.vue', { eager: true })
    const notificationList: Record<string, ComponentI> = import.meta.glob('../components/notification/**/*.vue', {
      eager: true,
    })
    const list = {
      ...componentList,
      ...notificationList,
    }
    Object.entries(list).forEach(([key, component]) => {
      const componentString = key.split('/')
      const componentName = componentString[componentString.length - 1].split('.')[0]
      vue.component(componentName, component?.default)
    })
  },
}

export default initInjectedComponents
